var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55603 5.20251C1.83789 3.67528 2.91815 0.833984 5.21694 0.833984H14.7829C17.0817 0.833984 18.162 3.67528 16.4439 5.20251L12.7796 8.45957C12.6017 8.61773 12.4999 8.8444 12.4999 9.0824V17.5721C12.4999 19.057 10.7047 19.8006 9.65478 18.7506L7.9881 17.084C7.67554 16.7714 7.49994 16.3475 7.49994 15.9055V9.0824C7.49994 8.8444 7.39815 8.61773 7.22025 8.45957L3.55603 5.20251ZM5.21694 2.50065C4.45068 2.50065 4.09059 3.44775 4.6633 3.95683L8.32752 7.2139C8.86128 7.68833 9.16661 8.36832 9.16661 9.0824V15.9055L10.8333 17.5721V9.0824C10.8333 8.36832 11.1386 7.68833 11.6724 7.2139L15.3366 3.95683C15.9093 3.44775 15.5492 2.50065 14.7829 2.50065H5.21694Z",
    fill: "#005B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupFilterIcon);
export default __webpack_public_path__ + "static/media/group-filter-icon.460b12cb936e5cab6e57451176fbb648.svg";
export { ForwardRef as ReactComponent };